import React, { useState } from 'react';
import {
  Table, TableRow, TableCell, TableHead, TableBody,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useEffectAsync } from '../reactHelper';
import { useTranslation } from '../common/components/LocalizationProvider';
import PageLayout from '../common/components/PageLayout';
import CollectionFab from '../settings/components/CollectionFab';
import CollectionActions from '../settings/components/CollectionActions';
import TableShimmer from '../common/components/TableShimmer';
import { useSuperManager } from '../common/util/permissions';
import SearchHeader, { filterByKeyword } from '../settings/components/SearchHeader';
import { formatTime } from '../common/util/formatter';
import RatesMenu from './components/RatesMenu';
import { centToEur } from '../common/util/converter';

const useStyles = makeStyles((theme) => ({
  columnAction: {
    width: '1%',
    paddingRight: theme.spacing(1),
  },
}));

const SubscriptionsPage = () => {
  const classes = useStyles();
  const t = useTranslation();
  const superManager = useSuperManager();

  const [timestamp, setTimestamp] = useState(Date.now());
  const [items, setItems] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [loading, setLoading] = useState(false);

  useEffectAsync(async () => {
    setLoading(true);
    try {
      const response = await fetch('/api/subscriptions');
      if (response.ok) {
        setItems(await response.json());
      } else {
        throw Error(await response.text());
      }
    } finally {
      setLoading(false);
    }
  }, [timestamp]);

  return (
    <PageLayout menu={<RatesMenu />} breadcrumbs={['subscriptions']}>
      <SearchHeader keyword={searchKeyword} setKeyword={setSearchKeyword} />
      <Table>
        <TableHead>
          <TableRow>
            <TableCell className={classes.columnAction} />
            <TableCell>{t('sharedName')}</TableCell>
            <TableCell>{t('dateStart')}</TableCell>
            <TableCell>{t('dateEnd')}</TableCell>
            <TableCell>{`${t('reportDuration')} (GG)`}</TableCell>
            <TableCell>{t('freeMinutes')}</TableCell>
            <TableCell>{t('price')}</TableCell>
            <TableCell>{t('discount')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!loading ? items.filter(filterByKeyword(searchKeyword)).map((item) => (
            <TableRow key={item.id}>
              <TableCell className={classes.columnAction} padding="none">
                <CollectionActions
                  itemId={item.id}
                  editPath="/rates/subscription"
                  endpoint="credits"
                  setTimestamp={setTimestamp}
                />
              </TableCell>
              <TableCell>{item.name}</TableCell>
              <TableCell>{formatTime(item.datestart, 'date', false, true)}</TableCell>
              <TableCell>{formatTime(item.dateend, 'date', false, true)}</TableCell>
              <TableCell>{item.duration}</TableCell>
              <TableCell>{item.freeminutes}</TableCell>
              <TableCell>{centToEur(item.price)}</TableCell>
              <TableCell>{item.discountCategories && item.discountCategories.map((discountCategory) => <div key={discountCategory.id}>{`${discountCategory.name}: ${discountCategory.discount}%`}</div>)}</TableCell>
            </TableRow>
          )) : (<TableShimmer columns={3} endAction />)}
        </TableBody>
      </Table>
      {superManager && (<CollectionFab editPath="/rates/subscription" />)}
    </PageLayout>
  );
};

export default SubscriptionsPage;
